import React from "react";
import { node } from "prop-types";
import Block from "@insightfulscience/atomic-react/Block";
import initMapSeqInteractivity from "./initMapSeqInteractivity";

const legacyStyles = `
svg.sg-map {
	height: 100%;
	width: 100%;
}

.tooltip_table {
	max-width: 359px;
	text-align: left;
	position: absolute;
	left: 0px;
	top: 0px;
	margin-left: auto;
	margin-right: auto;
	font: 11px Verdana, sans-serif !important;
	background-color: #FAFEC6 !important;
	border: 1px solid #A6A6A6;
	box-shadow: 1px 1px 8px #AAA;
	vertical-align: top;
	visibility: hidden;
	padding-top: 4px;
	padding-left: 4px;
	padding-right: 4px;
	padding-bottom: 4px;
	width: auto !important;
	overflow: visible !important;
}

.tooltip_table .tooltip_recog svg {
	display: block;
	max-width: 100%;
}

.line-placeholder {
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
}

@keyframes placeHolderShimmer {
	0% {
		background-position: -800px 0
	}
	100% {
		background-position: 800px 0
	}
}
  
.line-placeholder-loader {
	animation-duration: 2s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
	animation-name: placeHolderShimmer;
	animation-timing-function: linear;
	background-color: #E7E5E5;
	background: linear-gradient(to right, #E7E5E5 0%, #F9F8F8 30%, #E7E5E5 60%);
	background-size: 800px 17px;
	height: 17px;
	width: 70%;
	position: relative;
	border-radius: 6px;
}
`;

function PlasmidLegacyZone({ children }) {
	initMapSeqInteractivity();

	return (
		<Block sx={{ textAlign: "center" }} className="container-map">
			<style>{legacyStyles}</style>
			{children}
		</Block>
	);
}
PlasmidLegacyZone.propTypes = {
	children: node,
};

export default PlasmidLegacyZone;
